import { render, staticRenderFns } from "./BlockContainer.vue?vue&type=template&id=380534c9&scoped=true&"
import script from "./BlockContainer.vue?vue&type=script&lang=ts&"
export * from "./BlockContainer.vue?vue&type=script&lang=ts&"
import style0 from "./BlockContainer.vue?vue&type=style&index=0&id=380534c9&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380534c9",
  null
  
)

export default component.exports